import { Tooltip } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import WindowSizeThresholdsEnum from '../../enums/WindowSizeThresholdsEnum';
import paths from '../../paths';
import { usePreferences } from '../Preferences/containers/PreferencesDataStore';
import PreferenceType from '../Preferences/PreferenceType';
import PreferenceName from '../Preferences/PreferenceName';
import LandingPagePreference, {
	getLandingPageCookie,
	LandingPageCookieName,
} from '../Preferences/LandingPagePreference';
import { withCookies } from 'react-cookie';
import { useUser } from './containers/UserDataStore';
import logo from '../../assets/images/logo.png';
import edelweissBooksun from '../../assets/images/edelweiss-booksun.svg';
import booksun from '../../assets/images/booksun.svg';
import { useTranslate } from '@above-the-treeline/localization';
import './navigationAnchor.less';

NavigationAnchor.propTypes = {
	cookies: PropTypes.object,
	isMobile: PropTypes.func,
};

function NavigationAnchor({ cookies, isMobile }) {
	const isMobileSize = isMobile();
	const { isAnonymous } = useUser();
	const { addUserPreferenceWithPromise, getPreference } = usePreferences();
	const { translate } = useTranslate();

	const landingPage = getPreference(
		PreferenceType.landingPage,
		PreferenceName.preferred,
	);

	const setEPlusAsLandingPageAndRedirectToEPlus = () => {
		const landingPageCookie = cookies.get(LandingPageCookieName);

		if (landingPage || (landingPageCookie && landingPageCookie !== '')) {
			addUserPreferenceWithPromise(
				PreferenceType.landingPage,
				PreferenceName.preferred,
				LandingPagePreference.EdelweissPlus,
			).then(() => {
				const cookie = getLandingPageCookie(
					LandingPagePreference.EdelweissPlus,
				);
				cookies.set(cookie.name, cookie.value, cookie.options);
				window.location = process.env.REACT_APP_EPLUS_LINK_URL;
			});
		} else {
			window.location = process.env.REACT_APP_EPLUS_LINK_URL;
		}
	};

	const ePlusIconMobile = (
		<div className="logo-frame-mobile">
			<a onClick={setEPlusAsLandingPageAndRedirectToEPlus}>
				<div className="header-link">
					<img
						src={booksun}
						className="go-to-edelweiss-logo"
						alt={translate('go_to_edelweiss')}
					/>
				</div>
			</a>
		</div>
	);

	const ePlusIconDesktop = (
		<div className="logo-frame">
			<a
				onClick={setEPlusAsLandingPageAndRedirectToEPlus}
				target="_parent">
				<div className="header-link">
					<Tooltip
						title={translate('go_to_edelweiss')}
						placement="bottom">
						<img
							src={edelweissBooksun}
							className="go-to-edelweiss-logo"
							alt={translate('go_to_edelweiss')}
						/>
					</Tooltip>
				</div>
			</a>
		</div>
	);

	return (
		<div className="navigation-anchors">
			<div className="logo-frame">
				<Logo />
			</div>
			{!isAnonymous() &&
				(isMobileSize ? ePlusIconMobile : ePlusIconDesktop)}
		</div>
	);
}

export default withCookies(
	withIsMobile(NavigationAnchor, WindowSizeThresholdsEnum.Medium),
);

const Logo = () => {
	return (
		<Link className="header-link" to={paths.home()}>
			<img src={logo} alt="community logo" className="community-logo" />
		</Link>
	);
};
